<h1 translate>ERROR_PAGE_ACCESS_DENIED</h1>
<h2 translate>ERROR_PAGE_ACCESS_DENIED_TITLE</h2>
<p translate>ERROR_PAGE_ACCESS_DENIED_PARA</p>
<p>
  <a *ngIf="(isInRole$('BO_BILLING_INVOICES_VIEW') | async)" [routerLink]="['']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
  <a *ngIf="!(isInRole$('BO_BILLING_INVOICES_VIEW') | async)" [routerLink]="[ '/','orders','list']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
</p>
